/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem } from '@molecules';
import { pluralize } from '@utils';
import { useMedia } from '@api/hooks';
import { getImage } from '@utils/media';

const VideoCarouselItem = ({ module: { content }, errors }) => {
  const { media } = useMedia(getImage(content.videos?.[0], 'thumbnailImage'));

  return (
    <InfoItem.WithError
      error={errors}
      size="large"
      image={media.src}
      description={pluralize(content.videos?.length, 'video')}
    >
      Inside Track Tokyo 2020
    </InfoItem.WithError>
  );
};

export default VideoCarouselItem;
